import { createTheme } from '@mui/material/styles';

const primaryMain = '#2F6F4E';
const primaryLight = '#5B8F6C';
const primaryDark = '#214E39';
const secondaryMain = '#A0B8A7';
const backgroundDefault = '#F3F6F4';
const backgroundPaper = '#FFFFFF';
const textPrimary = '#1F2933';
const textSecondary = '#6B7280';

const theme = createTheme({
  palette: {
    primary: {
      main: primaryMain,
      light: primaryLight,
      dark: primaryDark,
      contrastText: '#ffffff',
    },
    secondary: {
      main: secondaryMain,
      light: '#C3D4C8',
      dark: '#7C9785',
      contrastText: '#1F2933',
    },
    background: {
      default: backgroundDefault,
      paper: backgroundPaper,
    },
    text: {
      primary: textPrimary,
      secondary: textSecondary,
    },
    success: {
      main: '#22c55e',
    },
    warning: {
      main: '#f97316',
    },
    error: {
      main: '#ef4444',
    },
    info: {
      main: '#0ea5e9',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 500,
      color: textPrimary,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
      color: textPrimary,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
      color: textPrimary,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
      color: textPrimary,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 500,
      color: textPrimary,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
      color: textPrimary,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.6,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          padding: '8px 24px',
          fontSize: '0.95rem',
          fontWeight: 500,
        },
        contained: {
          boxShadow: `0 2px 8px rgba(47, 111, 78, 0.2)`,
          '&:hover': {
            boxShadow: `0 4px 12px rgba(47, 111, 78, 0.3)`,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08)',
          border: '1px solid rgba(0, 0, 0, 0.05)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRight: '1px solid rgba(0, 0, 0, 0.08)',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          margin: '2px 8px',
          '&:hover': {
            backgroundColor: 'rgba(47, 111, 78, 0.08)',
          },
          '&.Mui-selected': {
            backgroundColor: 'rgba(47, 111, 78, 0.12)',
            '&:hover': {
              backgroundColor: 'rgba(47, 111, 78, 0.16)',
            },
          },
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});

export default theme;
